import React from 'react';
import '../template-file-css/document-file-template.css'; 


export const ACS_DischargeSummary = ({
    itemsRef,
    showErrorFor, 
}) => {

    return (
        <form id='ACS_DischargeSummary' className='file-pdf-document'>
            <div className='file-template'>  


<p>
     <span className='eleHeader'>1. What is the living situation at discharge? </span>
     <textarea id="txtLivingSituation" name="txtLivingSituation" className='add-only'></textarea>
</p>

<p>
     <span className='eleHeader'>2. What are the Strengths, Needs, Abilities and Preferences of the individual?</span>
     <textarea id="txtStrengths" name="txtStrengths" className='add-only'></textarea>
</p>

<p>
     <span className='eleHeader'>3. What Services and support did A.C.E. Provide, while in care? </span>
     <textarea id="txtServices" name="txtServices" className='add-only'></textarea>
</p>

<p>
     <span className='eleHeader'>4. What were the most recent GOALS and OBJECTIVE from treatment Plan? </span>
     <textarea id="txtTreatmentPlan" name="txtTreatmentPlan" className='add-only'></textarea>
</p>

<p>
     <span className='eleHeader'>5. What were the outcomes of the most recent treatment plan GOALS and OBJECTIVE?</span>
     <textarea id="txtTreatmentPlanGoals" name="txtTreatmentPlanGoals" className='add-only'></textarea>
</p>

<p>
     <span className='eleHeader'>6.  What outside organization did you refer client too. If not referred out, please explain.</span>
     <textarea id="txtReferred" name="txtReferred" className='add-only'></textarea>
</p>

<p>
     <span className='eleHeader'>7.  What is the plan of services, please include if an appointment was schedule (Please be specific)?</span>
     <textarea id="txtPlanOfServices" name="txtPlanOfServices" className='add-only'></textarea>
</p>

<p>
     <span className='eleHeader'>8.  What is the reason for discontinuing of services? </span>
     <textarea id="txtDiscontinuing" name="txtDiscontinuing" className='add-only'></textarea>
</p>

<p>
     <span className='eleHeader'>9.  Summary of Discharge </span>
     <textarea id="txtDischargeSummary" name="txtDischargeSummary" className='add-only'></textarea>
</p> 

 

                



            </div>
        </form>

    )
}    